import { render } from "./InvoiceReviewDetails.vue?vue&type=template&id=8cffeb7a"
import script from "./InvoiceReviewDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceReviewDetails.vue?vue&type=script&lang=js"

import "./InvoiceReviewDetails.vue?vue&type=style&index=0&id=8cffeb7a&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__